import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Role } from '../models';
import { environment } from '../../../environments/environment';

/**
 * Rollen-Guard, backend-unabhängig (WP und Spring Boot liefern denselben
 * roles-Claim, siehe docs/api-contract.md Berechtigungsmatrix). Nicht
 * eingeloggt → /login; eingeloggt aber Rolle fehlt → Dashboard.
 *
 * No-Op im Nonce-Build (environment.authStrategy !== 'jwt'): dort gibt es
 * kein Rollen-Konzept in der GUI, WP-Capabilities entscheiden serverseitig.
 */
export function roleGuard(allowed: Role[]): CanActivateFn {
  return () => {
    if (environment.authStrategy !== 'jwt') {
      return true;
    }

    const authService = inject(AuthService);
    const router       = inject(Router);

    if (!authService.isAuthenticated()) {
      return router.createUrlTree(['/login']);
    }
    if (!authService.hasAnyRole(allowed)) {
      return router.createUrlTree(['/dashboard']);
    }
    return true;
  };
}
